module.exports = __webpack_public_path__ + "static/section1-730113fca48435dde2720e63f0476986.jpg";